var smsRelativePath = '/sms';
export var createSmsApi = function (baseUrl, http) {
    var smsApiUrl = baseUrl + smsRelativePath;
    return {
        sendAgentMessage: function (smsDto) { return http.post(smsApiUrl + "/message", smsDto); },
        createAgentSmsTickets: function (outboundSmsDto) { return http.post(smsApiUrl + "/tickets/outbound", outboundSmsDto); },
    };
};
//# sourceMappingURL=index.js.map